"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOpponentWithMaxTime = exports.EjectPlayerPopButton = exports.EjectPlayerDialog = exports.EjectPlayerButton = void 0;
__exportStar(require("./EjectPlayer"), exports);
var EjectPlayerButton_1 = require("./EjectPlayerButton");
Object.defineProperty(exports, "EjectPlayerButton", { enumerable: true, get: function () { return __importDefault(EjectPlayerButton_1).default; } });
var EjectPlayerDialog_1 = require("./EjectPlayerDialog");
Object.defineProperty(exports, "EjectPlayerDialog", { enumerable: true, get: function () { return __importDefault(EjectPlayerDialog_1).default; } });
var EjectPlayerPopButton_1 = require("./EjectPlayerPopButton");
Object.defineProperty(exports, "EjectPlayerPopButton", { enumerable: true, get: function () { return __importDefault(EjectPlayerPopButton_1).default; } });
var useOpponentWithMaxTime_1 = require("./useOpponentWithMaxTime");
Object.defineProperty(exports, "useOpponentWithMaxTime", { enumerable: true, get: function () { return __importDefault(useOpponentWithMaxTime_1).default; } });
